import { gql } from "@apollo/client";

export const AUTHENTICATE_USER_USING_ACCESS_TOKEN = gql`
  mutation AuthenticateUserUsingAccessToken($accessToken: String!) {
    authenticateUserUsingAccessToken(accessToken: $accessToken) {
      message
      token
      userId
      email
      picture
      name
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation LogoutUser {
    logout
  }
`;
